/**
 * getFilteredData options for live explore replay map — ignores global selectionStore.
 */

export function liveReplayFilteredDataOptions(
  effectivePlaybackTime?: Date | null,
  timeWindowMinutes?: number
): {
  ignoreBrushSelection: true;
  effectivePlaybackTime?: Date | null;
  timeWindowMinutesOverride?: number;
} {
  return {
    ignoreBrushSelection: true,
    ...(effectivePlaybackTime !== undefined ? { effectivePlaybackTime } : {}),
    ...(timeWindowMinutes != null && timeWindowMinutes > 0
      ? { timeWindowMinutesOverride: timeWindowMinutes }
      : {}),
  };
}
